<script lang="ts" setup>
import { onMounted } from 'vue';
import { PageHero } from '~/components';
import { AppBreadcrumbs, AppTypography } from '~/components/base';
import useGetPrivacyPolicy from '~/composables/useGetPrivacyPolicy';
import PrivacyPolicyPageContent from '~/utils/contents/pages/PrivacyPolicyPage';

definePageMeta({
  auth: false,
});

useHead({
  title: PrivacyPolicyPageContent.seo.title,
});

const breadcrumbs = [
  { label: 'About', to: '/support' },
  { label: 'Privacy Policy' },
];

const { privacyPolicy, lastUpdated, getPrivacyPolicy } = useGetPrivacyPolicy();

onMounted(() => {
  getPrivacyPolicy();
});
</script>

<template>
  <div class="privacy-policy-page">
    <PageHero constrained max-width="max-w-3xl">
      <AppBreadcrumbs
        :custom-breadcrumbs="breadcrumbs"
        class="hidden px-0 lg:flex"
      />

      <div class="privacy-policy-page__content">
        <AppTypography type="title-1" class="mb-6 text-left lg:text-center">
          {{ PrivacyPolicyPageContent.title }}
        </AppTypography>
        <AppTypography
          v-if="lastUpdated"
          type="footnote"
          class="text-color-tertiary mb-4"
        >
          Last updated: {{ lastUpdated }}
        </AppTypography>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="privacyPolicy"></div>
      </div>
    </PageHero>
  </div>
</template>

<style lang="scss" scoped>
.privacy-policy-page {
  &__content {
    @media (min-width: 1024px) {
      padding: $spacing-5xl;
      border-radius: $radius-2xl;
      background-color: $surface-color-bg;
    }

    // The CMS content is authored with Filament's RichEditor (bold, italic,
    // underline, strike, sub/superscript, links, headings, lists,
    // blockquote, inline/block code, table) and rendered here via v-html —
    // see the rich-text-content mixin for why this override is needed.
    @include rich-text-content;
  }
}
</style>
